<template>
  <div class="m-0 py-0" :class="{ 'btn btn-sm btn-primary': cart_counter > 0 }">
    <icon name="SHOPPING_CART" />
    <span v-if="cart_counter > 0" class="ms-1">
      {{ cart_counter }}
    </span>
  </div>
</template>

<script lang="ts">
import icon from "@pdfking/workflow/components/icon"
import proxy from "@pdfking/workflow/utils/proxy"
import user from "../state/user"

export default {
  components: {
    icon,
  },
  computed: proxy(user, ["cart_counter"]),
  props: [] as const,
}
</script>
